import { useContext } from 'react';
import Context from '../../../context';
import './Button.scss';

const Button = ({ className, children, outline, coloredText, isPortalPreview, ...props}) => {
  const { composerData } = useContext(Context);

  const capitalizeFirstLetter = item => {
    if (typeof item === 'string') {
      return item.charAt(0).toUpperCase() + item.slice(1);
    }
    return item;
  };

  return (
    <button
      className={`button ${className ? className : ''} ${outline ? 'outline' : ''} ${coloredText ? 'color' : ''} ${composerData?.settings?.button_square_corners ? 'button-square-corners' : ''} ${isPortalPreview ? 'not-allowed' : ''}`}
      {...props}
    >
      {capitalizeFirstLetter(children)}
    </button>
  );
};

export default Button;
